import { render, staticRenderFns } from "./OrdenTrabajoCard.vue?vue&type=template&id=c5e478fe&"
import script from "./OrdenTrabajoCard.vue?vue&type=script&lang=js&"
export * from "./OrdenTrabajoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports